module.exports = __webpack_public_path__ + "static/img/sound_ky.d04dfc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sound_ky.png
// module id = XjlS
// module chunks = 128